var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "125px",
    height: "123px",
    viewBox: "0 0 125 123",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.839685%",
    y1: "100%",
    x2: "75.7082063%",
    y2: "26.796875%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1750DA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103EAF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 30,
    y: 33,
    width: 64,
    height: 64,
    rx: 32
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.6%",
    y: "-1.6%",
    width: "103.1%",
    height: "106.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.086645154 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Molecules-/-Modal--/-Verify",
    transform: "translate(-235.000000, -147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email",
    transform: "translate(234.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7836878,0.893524479 L5.03317446,41.3347528 C2.95537548,43.0541696 1.01020196,45.0598719 1,49.6097657 L124,50 C124.010121,45.4501062 123.059638,44.2555461 120.990341,42.5259048 L65.2417359,0.908861199 C63.6232648,-0.297262309 61.4088818,-0.303484565 59.7836878,0.893524479 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.261604,0.893524479 L5.0659645,41.3347528 C2.97127284,43.0541696 1.0102849,45.0598719 1,49.6097657 L125,50 C125.010203,45.4501062 124.051993,44.2555461 121.965872,42.5259048 L65.7640264,0.908861199 C64.132397,-0.297262309 61.9000109,-0.303484565 60.261604,0.893524479 Z",
    id: "Path",
    fill: "#E67F45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91270358,45.2589987 L121.06667,44.9996762 C123.275804,44.9947441 125.070659,46.7816024 125.075591,48.9907359 C125.075597,48.9934511 125.0756,48.9961664 125.075601,48.9988816 L125.087576,110.049546 C125.086732,116.83425 119.577948,122.334285 112.781505,122.336073 L13.1841691,122.334579 C6.50979001,122.334479 1.09905483,116.93309 1.09895384,110.27024 L0.92164463,49.2679198 C0.915315178,47.0587899 2.70103779,45.2628052 4.91016773,45.2564757 C4.91101113,45.2564733 4.91185453,45.2564712 4.91269793,45.2564693 Z",
    id: "Path",
    fill: "#FFBD27",
    transform: "translate(63.004602, 83.667870) rotate(0.130000) translate(-63.004602, -83.667870) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125,50 L124.861729,112.43664 C124.846664,117.730751 120.546445,122.011311 115.25447,121.999978 L11,121.767725",
    id: "Path",
    fill: "#F8D9B5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF9B2F",
    points: "75 56.235169 70.7533029 53 59.5040791 67.5750133 53.2563543 62.8155974 50 67.0346662 58.3702704 73.4018276 58.3702704 73.4018276 60.5169054 75"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyIcon);
export default __webpack_public_path__ + "static/media/verify-icon.4b2d69046d185c8d80d52e451fb93d04.svg";
export { ForwardRef as ReactComponent };